/* Mega menu — abre/fecha por hover + teclado; troca de material no finder.
   CSS já faz :hover/:focus-within como fallback; o JS adiciona .is-open p/
   controle explícito (só um aberto), Escape p/ fechar e as abas do finder. */
(function () {
  var root = document.querySelector('[data-sv-mm]');
  if (!root) return;

  var items = Array.prototype.slice.call(root.querySelectorAll('[data-sv-mm-item]'));

  function closeAll(except) {
    items.forEach(function (li) {
      if (li !== except) li.classList.remove('is-open');
    });
  }
  function open(li) {
    if (!li.querySelector('[data-sv-mm-panel]')) return;
    closeAll(li);
    li.classList.add('is-open');
  }
  function close(li) {
    li.classList.remove('is-open');
  }

  items.forEach(function (li) {
    if (!li.querySelector('[data-sv-mm-panel]')) return;
    li.addEventListener('mouseenter', function () { open(li); });
    li.addEventListener('mouseleave', function () { close(li); });
    li.addEventListener('focusin', function () { open(li); });
    li.addEventListener('focusout', function (e) {
      if (!li.contains(e.relatedTarget)) close(li);
    });
    // clicar num link navega → fecha
    li.addEventListener('click', function (e) {
      if (e.target.closest('a')) close(li);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  // Finder: abas de material
  var finder = root.querySelector('[data-sv-mm-finder]');
  if (finder) {
    var tabs = Array.prototype.slice.call(finder.querySelectorAll('[data-sv-mm-tab]'));
    var panels = Array.prototype.slice.call(finder.querySelectorAll('[data-sv-mm-material]'));
    function activate(key) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-sv-mm-tab') === key;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-sv-mm-material') === key);
      });
    }
    tabs.forEach(function (t) {
      var key = t.getAttribute('data-sv-mm-tab');
      t.addEventListener('mouseenter', function () { activate(key); });
      t.addEventListener('focus', function () { activate(key); });
      t.addEventListener('click', function () { activate(key); });
    });
  }
})();
